import { render } from "./WorkspaceCard.vue?vue&type=template&id=263740cc&scoped=true"
import script from "./WorkspaceCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceCard.vue?vue&type=script&lang=js"

import "./WorkspaceCard.vue?vue&type=style&index=0&id=263740cc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-263740cc"

export default script